import React from 'react'

export const StatusPill = ({ status, className, ...otherProps }) => (
  <span className={['StatusPill', className].filter((f) => !!f).join(' ')} {...otherProps}>
    {status}
  </span>
)

export default StatusPill
